import { render, staticRenderFns } from "./BingoPage.vue?vue&type=template&id=226148ba&scoped=true"
import script from "./BingoPage.vue?vue&type=script&lang=js"
export * from "./BingoPage.vue?vue&type=script&lang=js"
import style0 from "./BingoPage.vue?vue&type=style&index=0&id=226148ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226148ba",
  null
  
)

export default component.exports